import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
} from '@mui/material';

import { useTranslation } from 'react-i18next';
import VideoCapture from './BarcodeScanner';

const BarcodeScannerModal = ({ open, onClose, onCodeScanned }) => {
  const { t } = useTranslation(['button', 'orders', 'glossary']);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('barcode.select_cam_modal', { ns: 'description' })}
      </DialogTitle>
      <DialogContent>
        <VideoCapture onDetected={onCodeScanned} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          {t('close', { ns: 'button', defaultValue: 'Cerrar' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BarcodeScannerModal;
